// In App review is only supported on Native Apps.
export const requestInAppReview = () => {return}